// extracted by mini-css-extract-plugin
module.exports = {"content":"success_content__7hZdT","text":"success_text__xfDOV"};